import React, { useState, useEffect, useMemo, useContext } from "react";

import { Box } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';

import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";

import ImageHandler from "./ImageHandler";

import { PrivateRoutesContext } from "app/PrivateRoutesContext";

export default function LogoSettings () {
  const { companyId, error } = useContext(PrivateRoutesContext);

  const sqrImgMaxWidth = 500;
    const sqrImgMaxHeight = 500;

    const rectImgMaxWidth = 1000;
    const rectImgMaxHeight = 500;

    const [sqrLogo, setSqrLogo] = useState(null);
    const [sqrLogoIsUpdated, setSqrLogoIsUpdated] = useState(false);
    const [rectLogo, setRectLogo] = useState(null);
    const [rectLogoIsUpdated, setRectLogoIsUpdated] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    useEffect(() => {
        loadLogo("sqr", setSqrLogo);
        loadLogo("rect", setRectLogo);
    },[companyId]);

    const sqrLogoSrc = useMemo(
        () => { console.log(sqrLogo, "updating sqr"); return sqrLogo ? ((typeof sqrLogo === 'string' || sqrLogo instanceof String) ? sqrLogo : window.URL.createObjectURL(sqrLogo)) : null; },
        [sqrLogo]
      )
      
    const rectLogoSrc = useMemo(
        () => rectLogo ? ((typeof rectLogo === 'string' || rectLogo instanceof String) ? rectLogo : window.URL.createObjectURL(rectLogo)) : null,
        [rectLogo]
      )

    const sqr = {
        title: "Square Logo",
        setLogo: setSqrLogo,
        setIsUpdated: setSqrLogoIsUpdated,
        maxWidth: sqrImgMaxWidth,
        maxHeight: sqrImgMaxHeight,
        src: sqrLogoSrc,
    };

    const rect = {
        title: "Rectangular Logo",
        setLogo: setRectLogo,
        setIsUpdated: setRectLogoIsUpdated,
        maxWidth: rectImgMaxWidth,
        maxHeight: rectImgMaxHeight,
        src: rectLogoSrc,
    };

    const handleUpdateAppearance = () => {
      setIsUpdating(true);

        const formData = new FormData();
        formData.append("squareLogo", sqrLogo);
        formData.append("isSquareLogoUpdated", sqrLogoIsUpdated);
        formData.append("rectangularLogo", rectLogo);
        formData.append("isRectangularLogoUpdated", rectLogoIsUpdated);

        apiPost(apiUrls.uploadImage(companyId), formData, {
            headers: {
              "content-type": "multipart/form-data",
              Accept: "*/*",
            }}).then((response) => {
              setIsUpdating(false);
              // SUCCESS
            });
    }

  
  const loadLogo = (shape, setter) => {
    apiGet(apiUrls.downloadImage(companyId, shape)).then(response => {
      if (response.data) {
        setter(`data:image/${response.data.extension};base64, ${response.data.file}`);
      }
      }).catch(
        (response) => {
          setter("");
        }
      );
  };

  return (
    <Box className="container-fluid">
        <Box className="mb-2 row">
            <ImageHandler image={rect} />
            <ImageHandler image={sqr} />
        </Box>
        <Box className="d-flex">
            <Box className="px-1">
                <LoadingButton
                    variant="outlined"
                    onClick={handleUpdateAppearance}
                    disabled={!rectLogoIsUpdated && !sqrLogoIsUpdated}
                    startIcon={<UploadOutlinedIcon />}
                    loading={isUpdating}
                    loadingPosition="start"
                >
                    Update Logos
                </LoadingButton>
            </Box>
        </Box>
    </Box>
  );
}
